import { Button, ButtonGroup, Grid, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ColorLine from "../../components/ColorLine";
import DashboardSlide from "../../components/DashboardSlide";
import { useStyles } from "./AboutStyles";
import ScrollAnimation from "react-animate-on-scroll";
import { getDoc, getDocs } from "firebase/firestore/lite";
import {
  clientColRefWithOrder,
  TestimonialColRefWithOrder,
  userDocRef,
} from "../../database/Firebase";
import AvatarComponent from "../../components/AvatarComponent";
import { styled } from "@mui/styles";
import colors from "../../themes/colors";
import { useLocation } from "react-router-dom";
import { CompanyKey } from "../../constant";
import { LocalStorage } from "../../cache/localStorage";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

const scrollToRef = (ref: any) =>
  window.scrollTo({ top: ref.current.offsetTop, behavior: "smooth" });

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: colors.green,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: colors.green,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: colors.green,
      borderRadius: 0,
      borderWidth: 1,
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
    },
    "&:hover fieldset": {
      borderColor: colors.green,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.green,
    },
  },
});

function AboutComponent() {
  let navigate = useNavigate();

  const classes = useStyles();
  const [clientList, setClientList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [emailValid, setEmailValid] = useState("");
  const [viewCount, setViewCount] = useState(2);

  let location = useLocation();
  const AboutRef = useRef(null);
  const executeSectionScroll = () => scrollToRef(AboutRef);

  useEffect(() => {
    // eslint-disable-next-line
    getClient();
  }, []);

  const viewMore = () => {
    setViewCount((prevState) => prevState + 1);
  };

  const chunks = function (array: any, size: any) {
    let results = [];
    while (array.length) {
      results.push(array.splice(0, size));
    }
    return results;
  };

  let getClient = async () => {
    setIsLoading(true);
    const response = await getDocs(clientColRefWithOrder);
    let storeClient: any = [];
    response.forEach((doc) => {
      storeClient.push({
        ...doc.data(),
        doc_id: doc.id,
      });
    });
    if (storeClient.length) {
      let arr = [...chunks(storeClient, 5)];
      setClientList(arr);
      setIsLoading(false);
    }
    setIsLoading(false);
    if (location.pathname === "/Client-List") {
      executeSectionScroll();
    }
  };
  return (
    <>
      <section>
        <DashboardSlide
          title="Quality is our Trust"
          description=""
          color="green"
          img="aboutBg"
        />
      </section>
      <ColorLine />
      <section className={classes.section}>
        <div className="marginContainer">
          <p className={classes.sectionTitle}>Who we're</p>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item style={{ textAlign: "center" }}>
              <p>
                JuJu designz, a young and budding startup fascinated in making
                adorable creative works ventred on Aug 7 of 2018 and paved our
                path towards a multi-faceted online service provider of
                captivating design solutions to make your brand renowned also
                provide innovative gifting options. We ideate uniqueness in our
                creative services. We'll be motivated and amused to see our
                customers exhilarated.
              </p>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className={classes.section}>
        <div className="marginContainer">
          <p className={classes.sectionTitle}>Vision</p>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item style={{ textAlign: "center" }}>
              <p>
                Our vision is to be a leading creative design agency that is
                known for pushing boundaries and delivering exceptional results
                for our clients. We strive to constantly innovate and evolve our
                approach to design in order to stay ahead of industry trends and
                exceed client expectations.
              </p>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className={classes.section}>
        <div className="marginContainer">
          <p className={classes.sectionTitle}>Mission</p>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item style={{ textAlign: "center" }}>
              <p>
                Our mission is to craft visually stunning and effective design
                solutions that help our clients stand out in their industry and
                achieve their business goals.
              </p>
            </Grid>
          </Grid>
        </div>
      </section>
      <section
        ref={AboutRef}
        className={classes.section}
        style={{ paddingBottom: 80 }}
      >
        <p className={classes.sectionTitle}>Trusted Clients</p>

        <ScrollAnimation animateIn="fadeIn">
          <div className="marginContainer">
            {clientList &&
              clientList.slice(0, viewCount).map((item, index) => {
                return <AvatarComponent key={index} ClientList={item} />;
              })}
          </div>
          <div style={{ textAlign: "center" }}>
            {/* <motion.div whileHover={{ scale: 0.99 }}> */}
            {clientList.length !== viewCount && (
              <Button
                className="jump"
                onClick={() => viewMore()}
                style={{
                  background:
                    "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
                  color: "white",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                  marginTop: 30,
                  textTransform: "capitalize",
                }}
                size="small"
              >
                View More
              </Button>
            )}

            {/* </motion.div> */}
          </div>
        </ScrollAnimation>
      </section>
      <section className={classes.section}>
        <div className="marginContainer">
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Grid item sm={5}>
              <p style={{ fontWeight: "bold", fontSize: 30 }}>
                Are you interested in Partnership?
              </p>
              <p style={{ marginTop: 15 }}>
                Let's join hands to create amazing business that stands above.
                Through our partnership let's together accelerate our business
                to reach out our amazing customers. Are you ready to begin the
                journey?
              </p>
              <Button
                onClick={() => navigate("/Contact")}
                className="jump"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
                  color: "white",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                  marginTop: 15,
                  textTransform: "capitalize",
                }}
                size="small"
              >
                Join Us
              </Button>
            </Grid>
            <Grid item sm={6} pt={4} style={{ textAlign: "left" }}>
              <img
                src={require("../../assets/about_partnership.jpg")}
                width={"80%"}
                height={"80%"}
                alt="juju Designz popup"
                style={{ borderRadius: 30 }}
              />
            </Grid>
          </Grid>
        </div>
      </section>
      <section className={classes.section}>
        <div className="marginContainer">
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Grid
              item
              sm={6}
              order={{ xs: 3, sm: 2 }}
              style={{ textAlign: "left" }}
              pt={4}
            >
              <img
                src={require("../../assets/about_sponsor.jpg")}
                width={"80%"}
                height={"80%"}
                alt="juju Designz popup"
                style={{ borderRadius: 30 }}
              />
            </Grid>
            <Grid item sm={6} order={{ xs: 2, sm: 3 }}>
              <p style={{ fontWeight: "bold", fontSize: 30 }}>
                Are you looking for Sponsor?
              </p>
              <p style={{ marginTop: 15 }}>
                We are delighted to be one for you. Would be happily satisfied
                if we could add some value to your business.
              </p>
              <Button
                onClick={() => navigate("/Contact")}
                className="jump"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
                  color: "white",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                  marginTop: 15,
                  textTransform: "capitalize",
                }}
                size="small"
              >
                Let's discuss
              </Button>
            </Grid>
          </Grid>
        </div>
      </section>

      <section>
        <div className="marginContainer">
          <Grid
            container
            alignItems={"center"}
            justifyContent={"center"}
            mb={4}
            mt={4}
          >
            <Grid
              item
              xs={12}
              sm={12}
              p={4}
              style={{
                backgroundColor: colors.dark_blue,
                borderRadius: 10,
                textAlign: "center",
              }}
            >
              <p
                style={{ paddingTop: 10 }}
                className={classes.darkSectionTitle}
              >
                Get Our Brochure
              </p>
              <ButtonGroup variant="contained" aria-label="large button group">
                <CssTextField
                  id="outlined-adornment-weight"
                  value={emailValid}
                  onChange={(e) => {
                    setEmailValid(e.target.value);
                  }}
                  placeholder="Enter Mail ID*"
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{
                    "aria-label": "weight",
                  }}
                  style={{ width: "70%", borderRadius: 0 }}
                  sx={{
                    input: {
                      color: colors.white,
                      borderColor: colors.green,
                      borderRadius: 0,
                    },
                  }}
                />
                <Button
                  // onClick={() => {
                  //   var validRegex =
                  //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                  //   if (emailValid.match(validRegex)) {
                  //     setEmailValid("");
                  //     window.open(
                  //       LocalStorage.get(CompanyKey)
                  //         ? LocalStorage.get(CompanyKey).planUrl
                  //         : ""
                  //     );
                  //   } else {
                  //     alert("Enter valid email ID to get the plan details !");
                  //   }
                  // }}
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
                    borderRadius: 0,
                    borderTopRightRadius: 10,
                    borderBottomRightRadius: 10,
                    textTransform: "capitalize",
                  }}
                >
                  Download
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </div>
      </section>
      {/* SEO */}
      <Helmet>
        <title>JuJu Designz About</title>
        <meta
          name="description"
          content="JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider  juju designs juju, designsz of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated  juju designs juju, designsz and  juju designs juju, designsz amused to see our customers exhilarated. location : salem , Tamil Nadu , graphics design , web designing , mobile app development . best startup in salem , best web development in salem , juju designs juju, designsz.salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation.JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a >good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store"
        />
      </Helmet>
    </>
  );
}

export default AboutComponent;
